import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import useAuth from '../../../hooks/useAuth';

const MoreProductsBooking = () => {
    const { register, handleSubmit, reset } = useForm();
    const [moreProduct, setMoreProduct] = useState({});
    const { productId } = useParams();
    const { user } = useAuth();

    useEffect(() => {
        fetch(`https://fathomless-bastion-71123.herokuapp.com/products/${productId}`)

            .then(res => res.json())
            .then(data => setMoreProduct(data))
    }, []);




    const onSubmit = data => {

        console.log(data);
        //use axios for post API

        axios.post('https://fathomless-bastion-71123.herokuapp.com/orders', data)
            .then(res => {
                if (res.data.insertedId) {
                    alert('Booking Successfully Complate');
                    reset();
                }
            })
    }
    return (
        <div className="booking-container">
            <div>
                <h2> Brand  {moreProduct.name}</h2>
                <img src={moreProduct.img} alt="" />
                <p>Bike Model:  {moreProduct.model}</p>
                <p>Total Price :  $ {moreProduct.price}</p>

                <p className="px-5" >{moreProduct.description}</p>


            </div>



            <div className="add-product">
                <h2> Please  Booking </h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <input {...register("user", { required: true, maxLength: 20 })} defaultValue={user.displayName} />
                    <input {...register("email",)} defaultValue={user.email} />

                    <input {...register("name", { required: true, maxLength: 20 })} defaultValue={moreProduct.name} />
                    <input {...register("model",)} defaultValue={moreProduct.model} />
                    <input type="number" {...register("price")} defaultValue={moreProduct.price} />

                    <input type="number" {...register("number")} placeholder="Your Mobile number" />

                    <textarea  {...register("address")} placeholder="Your Address" />

                    <input className="btn btn-warning" type="submit" />
                </form>
            </div>
        </div>

    );
};

export default MoreProductsBooking;